import { render, staticRenderFns } from "./PendingTransfersBice.vue?vue&type=template&id=501cd451&lang=pug"
import script from "./PendingTransfersBice.vue?vue&type=script&lang=js"
export * from "./PendingTransfersBice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports